import { MedicalImaging } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { MedicalInformationPreview } from '../../MedicalInformationModal/MedicalInformationModal';

export const mapMedicalImagingToMedicalInformation = (medicalImaging: MedicalImaging): MedicalInformationPreview => ({
   type: 'MEDICAL_IMAGING',
   id: medicalImaging.medicalInformation.id,
   createdBy: medicalImaging.medicalInformation.createdBy,
   creationDate: medicalImaging.medicalInformation.creationDate,
   description: medicalImaging.medicalInformation.description || '-',
   unsignedAttachmentCount: medicalImaging.medicalInformation.unsignedAttachmentCount,
   attachments: medicalImaging.medicalInformation.attachments,
   attachmentsSignedBy: medicalImaging.medicalInformation.attachmentsSignedBy,
   medicalInformationRemoved: medicalImaging.medicalInformation.medicalInformationRemoved,
});
